<div class='mt-8'>
  <div class="mb-4 fx-column">
    @if (showTitle) {
      <span class='h2'>{{'Immagini' | translate}}</span>
    }
    @if (parentDatasetRS.record.value && parentDatasetRS.record.value.allowed_actions && parentDatasetRS.record.value.allowed_actions.includes("edit")) {
      <span class='h5 secondary-text'>{{'Carica più immagini per migliorare la visibilità' | translate}}</span>
    }
  </div>
  <div class="fx-row fx-sm-column fx-xs-column">
    @if (parentDatasetRS.record.value && parentDatasetRS.record.value.allowed_actions && parentDatasetRS.record.value.allowed_actions.includes("edit")) {
      <div class='drop-file-box'
        [class.dragging]='dragging'
        (dragleave)='onFileDragLeave($event)'
        (dragstart)='onFileDragStart($event)'
        (dragover)='onFileDragOver($event)'
        (drop)='onFileDrop($event)'>
        @if (uploading) {
          <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
          <p>{{'Caricamento in corso...' | translate}}</p>
        }
        @if (!uploading && !inputFile) {
          <p><strong>{{'Trascina i file qui per caricarlo' | translate}}</strong></p>
          <p>{{'Sono supportati i file: .jpeg, .png' | translate}}</p>
          <span>{{'Formato' | translate}}: {{imageWidth}} x {{imageHeight}}</span>
          <div class='box-file-input'>
            <mat-icon>image</mat-icon>
            <span class='ml-4'>{{'Cerca nel computer' | translate}}</span>
            <input type='file' #fileInput (change)="onFileChange($event)"/>
          </div>
        }
        @if (inputFile && !uploading) {
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="imageRatio"
            [resizeToWidth]="imageWidth"
            [resizeToHeight]="imageHeight"
            [cropperMinWidth]="imageWidth"
            [cropperMinHeight]="imageHeight"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [autoCrop]="true"
            format="jpeg"
            [imageQuality]="90"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (loadImageFailed)="loadImageFailed()"
          ></image-cropper>
        }
        @if (croppedFile && !uploading) {
          <button mat-flat-button color='accent' (click)='uploadFile()'>Carica</button>
        }
      </div>
    }
    <div class="thumbs_result fx-flex">
      @if (datasetACS.loading.value) {
        <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
      }
      <div cdkDropList [cdkDropListData]="dataList" (cdkDropListDropped)='onDropList($event)' class="carousel-images fx-row fx-wrap fx-justify-start fx-items-center">
        @for (document of dataList; track trackImageBy(i, document); let i = $index) {
          <div class='carousel-image-item' cdkDrag >
            <div class='carousel-image-container'>
              @if (parentDatasetRS.record.value && parentDatasetRS.record.value.allowed_actions && parentDatasetRS.record.value.allowed_actions.includes("edit")) {
                <button mat-icon-button color='warn'
                  (click)='removeImage(document)' [matTooltip]='"Elimina immagine" | translate'>
                  <mat-icon>delete</mat-icon>
                </button>
              }
              <span class='carousel-image-index'>{{i + 1}}</span>
              <img [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + document.id'>
            </div>
            <img *cdkDragPreview [alt]="'Immagine ' + (i + 1)" width='120' [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + document.id'>
          </div>
        }
      </div>
    </div>
  </div>
</div>